import { render, staticRenderFns } from "./ModalInquiryDelete.vue?vue&type=template&id=ca018802&"
import script from "./ModalInquiryDelete.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports